import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Grid from '@material-ui/core/Grid';

const ScopesFormatter = ({ scopes }) => {
  const intl = useIntl();
  return (
    <Grid container spacing={1}>
      {scopes?.length
        ? scopes.map(scope => (
            <Grid key={scope} item>
              <Chip
                label={scope
                  .split(':')
                  .map(part =>
                    intl.formatMessage({
                      id: `scopeParts.${part}`,
                      defaultMessage: part,
                      description: `label of the scope part ${part}`,
                    }),
                  )
                  .join(':')}
                size="small"
              />
            </Grid>
          ))
        : '-'}
    </Grid>
  );
};

ScopesFormatter.propTypes = {
  scopes: PropTypes.array,
};

ScopesFormatter.defaultProps = {
  scopes: [],
};

export default ScopesFormatter;
